import Vessel from './vessel.container'

export default Vessel
